import { type z } from 'zod'

export const withFallback = <T extends z.ZodTypeAny>(schema: T, fallback: z.infer<T>) => schema.catch(fallback)
